import { render } from "./HomeContent.vue?vue&type=template&id=2cfbd31c&scoped=true"
import script from "./HomeContent.vue?vue&type=script&lang=js"
export * from "./HomeContent.vue?vue&type=script&lang=js"

import "./HomeContent.vue?vue&type=style&index=0&id=2cfbd31c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfbd31c"]])

export default __exports__